import { Box, Typography } from "@mui/material";
import type React from "react";
import { useLocation } from "react-router-dom";
import { NavigationLinks } from "types";
import NavigationLink from "./navigation-link";
import NavigationUtils from "utils/navigation-utils";
import FormRestrictedContent from "components/containers/form-restricted-content";
import { useAppSelector } from "app/hooks";
import { selectKeycloak } from "features/auth-slice";
import { HeaderLogo } from "styled/layout-components/header";
import Config from "app/config";

/**
 * Navigation header component
 */
const NavigationHeader: React.FC = () => {
  const { pathname } = useLocation();

  const currentNavigation = NavigationUtils.matchNavigation(pathname);
  const keycloak = useAppSelector(selectKeycloak);
  
  /**
   * Renders navigation links
   */
  const renderNavigationLinks = () => (
    <Box
      component="nav"
      sx={{
        display: "flex",
        flexDirection: { xs: "row", sm: "column" },
        gap: "2px",
        overflowX: "auto",
        px: { xs: "8px", sm: "10px" },
        py: { xs: "8px", sm: "12px" }
      }}
    >
      <NavigationLink
        currentNavigation={ currentNavigation }
        navigation={ NavigationLinks.FORMS }
      />
      <FormRestrictedContent>
        <NavigationLink
          currentNavigation={ currentNavigation }
          navigation={ NavigationLinks.USERS }
        />
        <NavigationLink
          currentNavigation={ currentNavigation }
          navigation={ NavigationLinks.EDITOR }
        />
        { keycloak?.hasRealmRole("metatavu-admin") &&
          <NavigationLink
            currentNavigation={ currentNavigation }
            navigation={ NavigationLinks.SCRIPTS }
          />
        }
      </FormRestrictedContent>
    </Box>
  );

  /**
   * Component render
   */
  return (
    <>
      <Box
        sx={{
          display: { xs: "none", sm: "block" },
          p: "22px 20px 18px",
          borderBottom: "1px solid #eceeed"
        }}
      >
        <HeaderLogo sx={{ width: 148, height: 56 }}/>
        <Typography
          sx={{
            mt: 1.5,
            color: "#8a8f8c",
            fontSize: 11,
            fontWeight: 500,
            letterSpacing: "0.09em",
            textTransform: "uppercase"
          }}
        >
          { Config.get().theme.title }
        </Typography>
      </Box>
      { renderNavigationLinks() }
      <Box
        sx={{
          display: { xs: "none", sm: "block" },
          mt: "auto",
          p: "16px 20px",
          borderTop: "1px solid #eceeed"
        }}
      >
        <Typography
          sx={{
            color: "#4d4d4d",
            fontSize: 12,
            fontWeight: 500
          }}
        >
          Granlund Forms
        </Typography>
      </Box>
    </>
  );
};

export default NavigationHeader;